var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTileIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#E3EFE3;}\r\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:8;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.26,
    y: 17.26,
    className: "st1",
    width: 29.48,
    height: 29.48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.29,32c0,2.6,2.11,4.71,4.71,4.71s4.71-2.11,4.71-4.71S34.6,27.29,32,27.29S27.29,29.4,27.29,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.8,27.29c-0.44,0.92-0.05,2.02,0.87,2.46c0.06,0.03,0.12,0.05,0.18,0.07l1.25,0.44 c0.96,0.34,1.46,1.4,1.12,2.36c-0.19,0.52-0.6,0.94-1.12,1.12l-1.25,0.44c-0.96,0.34-1.46,1.4-1.12,2.36 c0.02,0.06,0.05,0.12,0.07,0.18l0.57,1.19c0.44,0.92,0.05,2.02-0.87,2.46c-0.5,0.24-1.09,0.24-1.59,0l-1.19-0.57 c-0.92-0.44-2.02-0.05-2.46,0.87c-0.03,0.06-0.05,0.12-0.07,0.18l-0.44,1.25c-0.34,0.96-1.4,1.46-2.36,1.12 c-0.52-0.19-0.94-0.6-1.12-1.12l-0.44-1.25c-0.34-0.96-1.4-1.46-2.36-1.12c-0.06,0.02-0.12,0.05-0.18,0.07l-1.19,0.57 c-0.92,0.44-2.02,0.05-2.46-0.87c-0.24-0.5-0.24-1.09,0-1.59l0.57-1.19c0.44-0.92,0.05-2.02-0.87-2.46 c-0.06-0.03-0.12-0.05-0.18-0.07l-1.25-0.44c-0.96-0.34-1.46-1.4-1.12-2.36c0.19-0.52,0.6-0.94,1.12-1.12l1.25-0.44 c0.96-0.34,1.46-1.4,1.12-2.36c-0.02-0.06-0.04-0.12-0.07-0.17l-0.57-1.19c-0.44-0.92-0.05-2.02,0.87-2.46 c0.5-0.24,1.09-0.24,1.59,0l1.19,0.57c0.92,0.44,2.02,0.05,2.46-0.87c0.03-0.06,0.05-0.11,0.07-0.17l0.44-1.25 c0.34-0.96,1.4-1.46,2.36-1.12c0.52,0.19,0.94,0.6,1.12,1.12l0.44,1.25c0.34,0.96,1.4,1.46,2.36,1.12 c0.06-0.02,0.12-0.05,0.18-0.07l1.19-0.57c0.92-0.44,2.02-0.05,2.46,0.87c0.24,0.5,0.24,1.09,0,1.59L39.8,27.29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTileIcon06);
export default __webpack_public_path__ + "static/media/feature-tile-icon-06.7fc92015e04c884d88903af1619b0092.svg";
export { ForwardRef as ReactComponent };